import { useEffect, useRef } from "react";
import { useAuth } from "src/context";
import { useNavigate, Outlet } from "react-router-dom";

export default () => {
  const { user, processMagicLink } = useAuth();
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    processMagicLink((error) => {
      if (error) {
        void navigate("/login", {
          state: { errorCode: (error as { code?: string }).code },
        });
      }
    });
  }, []);

  useEffect(() => {
    if (!user || !("accessToken" in user)) {
      timeoutRef.current = setTimeout(() => {
        void navigate(`/login`);
      }, 2000);

      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = undefined;
        }
      };
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    }
  }, [user]);

  return user && "accessToken" in user ? <Outlet /> : null;
};
